import React from 'react'
import Page from '../Page'

const CIS = ({ testResult }) => {
    return (
        <>
            <Page
                testResult={testResult}
                title="معرفی الگوی رفتاری CIS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد با الگوی رفتاری  CIS ترکیبی از دقت و تحلیل‌گری C  ،  ارتباط و تأثیرگذاری I  و صبوری و وفاداری S را در شخصیت خود دارند. این افراد معمولاً سیاست‌مدار، محتاط، دقیق، بااحساس و در عین حال تأثیرگذار هستند. برای آن‌ها نظم، روابط دوستانه، کمک به دیگران و استانداردهای شخصی بالا اهمیت زیادی دارد.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی شاخص آن‌ها چیست؟"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <ul className="list-disc pr-5 space-y-2">

                        <li>
                            <strong>S:</strong> دنبال حفظ آرامش و ثبات‌اند
                        </li>

                        <li>
                            <strong>I:</strong> تلاش می‌کنند تأثیر خوبی بر اطرافیان داشته باشند
                        </li>

                        <li>
                            <strong>C:</strong> همواره استانداردهای بالا و منطقی برای خود و دیگران تعریف می‌کنند
                        </li>

                    </ul>

                    <p>
                        این تیپ رفتاری بیشتر در محیط‌هایی موفق عمل می‌کند که ترکیبی از روابط انسانی، قواعد مشخص، و فضا برای بیان مهارت‌های فردی فراهم باشد.
                    </p>

                    <p><strong>مثال کاربردی:</strong></p>

                    <p>
                        فرض کنید فردی با الگوی <strong>CIS</strong> مدیر یک بخش آموزشی است. او برای اجرای یک دوره، ابتدا با دقت تمام محتواها را بررسی می‌کند <strong>C</strong>، سپس با شور و هیجان در مورد دوره صحبت می‌کند و افراد را تشویق به ثبت‌نام می‌کند <strong>I</strong>، و در تمام این مسیر، پیگیرانه و با صبر بالا کار تیمی را دنبال می‌کند <strong>S</strong>.
                    </p>

                    <p>
                        این فرد می‌تواند هم منظم باشد، هم روابط مثبت بسازد و هم به کیفیت خروجی اهمیت دهد.
                    </p>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ابعاد و توصیف ویژگی‌های رفتاری CIS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <p>
                        افراد با الگوی <strong>CIS</strong> ترکیبی از سه ویژگی اصلی دارند:
                    </p>

                    <ul className="list-disc pr-5 space-y-2">

                        <li>
                            <strong>C:</strong> Conscientious — قانون‌گرایی و تحلیل‌گری
                        </li>

                        <li>
                            <strong>I:</strong> Influence — تأثیرگذاری و ارتباط‌محوری
                        </li>

                        <li>
                            <strong>S:</strong> Steadiness — ثبات، وفاداری و صبوری
                        </li>

                    </ul>

                    <p>
                        این افراد ترکیب متعادلی از منطق، احساس و صبوری دارند و همین ویژگی آن‌ها را به انسان‌هایی چندوجهی، محترم، محتاط و اثرگذار تبدیل می‌کند.
                    </p>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="شاخصه‌های رفتاری CISها"
            >
                <div className='text-gray-800 leading-7'>

                    <ul className="space-y-3 list-disc pr-5">

                        <li>
                            <strong>C:</strong> دقیق و محتاط —
                            همیشه تلاش می‌کنند بهترین تصمیم را بگیرند؛ ترجیح می‌دهند با اطلاعات کامل پیش بروند و از اشتباه و نقد شدن گریزان‌اند.
                        </li>

                        <li>
                            <strong>I:</strong> ارتباط‌محور و کلامی —
                            دوست دارند مورد توجه قرار بگیرند، ارتباط اجتماعی خوبی دارند و در دل جمع‌ها راحت جا می‌گیرند؛ البته در مقایسه با یک High I، کنترل بیشتری بر بروز احساسات دارند.
                        </li>

                        <li>
                            <strong>S:</strong> صمیمی و باوفا —
                            برای آن‌ها روابط دوستانه عمیق، فضای صلح‌آمیز و ثبات بسیار مهم است. دوست ندارند باعث رنجش یا دلخوری دیگران شوند.
                        </li>

                        <li>
                            نظم‌دوست اما مردم‌دار —
                            در عین حال که به ساختار و چارچوب اهمیت می‌دهند، با دیگران به زبان مهربانی و احترام صحبت می‌کنند و معمولاً تلاش می‌کنند نظر جمع را نیز جلب کنند.
                        </li>

                    </ul>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نقاط قوت"
            >
                <div className='text-gray-800 leading-7 space-y-6'>

                    <ul className="space-y-2 list-disc pr-5">
                        <li>دارای تعادل بین منطق و احساس</li>
                        <li>برخورد محترمانه با دیگران</li>
                        <li>قابلیت سازگاری در کار تیمی</li>
                        <li>علاقه‌مند به یادگیری مستمر</li>
                        <li>حفظ کیفیت و اخلاق در کار</li>
                    </ul>

                    <div className="space-y-2">
                        <h3 className="font-semibold">نقاط قابل بهبود:</h3>
                        <ul className="space-y-2 list-disc pr-5">
                            <li>گاهی برای «نه گفتن» به دیگران دچار تعارف یا تردید می‌شوند.</li>
                            <li>به دلیل حساسیت بالا، در معرض خستگی ذهنی قرار می‌گیرند.</li>
                            <li>اگر تحت فشار قرار بگیرند، ممکن است اعتمادبه‌نفسشان پایین بیاید.</li>
                            <li>تمایل دارند گاهی برای جلب رضایت، بیش از حد از خواسته‌های خود بگذرند.</li>
                        </ul>
                    </div>

                    <div>
                        <p>
                            <strong>مثال کاربردی:</strong>
                            <br />
                            فرض کنید در یک تیم پروژه‌ای، قرار است یک ایده جدید مطرح شود. فرد
                            <strong> CIS </strong>
                            ابتدا با دقت شرایط را بررسی می‌کند
                            <strong>C</strong>،
                            با زبانی مهربان و دلنشین نظرات خود را مطرح می‌کند
                            <strong>I</strong>
                            و در نهایت، با صبر و همکاری، پیشنهاد سایرین را نیز می‌شنود و برای موفقیت تیم تلاش می‌کند
                            <strong>S</strong>.
                            چنین فردی می‌تواند پل ارتباطی عالی بین تیپ‌های سخت‌گیر و افراد احساسی‌تر باشد.
                        </p>
                    </div>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تشریح الگوی رفتاری CIS"
            >
                <div className='text-gray-800 leading-7 space-y-5'>

                    <p>
                        الگوی <strong>CIS</strong> مانند یک شخصیت سه‌بعدی متعادل است که همزمان از دقت،
                        لطافت و ارتباطات بهره می‌برد. این افراد معمولاً کمتر در مرکز توجه قرار می‌گیرند
                        اما در پشت صحنه، تأثیرگذاری بالا، نظم مثال‌زدنی و مهربانی کم‌نظیری از خود نشان می‌دهند.
                    </p>

                    <ul className="space-y-2 pr-4 list-disc">
                        <li>«آیا همه‌چیز درست و کامل انجام شده؟» <strong>C</strong></li>
                        <li>«آیا دیگران از من راضی هستند و احساس خوبی دارند؟» <strong>I</strong></li>
                        <li>«چطور می‌توانم به تیم کمک کنم و باعث آرامش جمع باشم؟» <strong>S</strong></li>
                    </ul>

                    <p>
                        این گفت‌وگوهای درونی، نشان‌دهنده عمق فکری، ملاحظه‌کاری و دلسوزی این افراد است.
                        آن‌ها به‌ندرت دچار رفتارهای تند یا شتاب‌زده می‌شوند و همواره به دنبال راهی هستند
                        که هم منطقی باشد، هم انسانی و هم آرام.
                    </p>

                </div>ّ
            </Page>

            <Page
                testResult={testResult}
                title="درون ذهن یک  CIS چه می‌گذرد؟"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <ul className="space-y-2 pr-4 list-disc">
                        <li>«آیا همه‌چیز درست و کامل انجام شده؟» <strong>C</strong></li>
                        <li>«آیا دیگران از من راضی هستند و احساس خوبی دارند؟» <strong>I</strong></li>
                        <li>«چطور می‌توانم به تیم کمک کنم و باعث آرامش جمع باشم؟» <strong>S</strong></li>
                    </ul>

                    <p>
                        این گفت‌وگوهای درونی، نشان‌دهنده عمق فکری، ملاحظه‌کاری و دلسوزی این افراد است.
                        آن‌ها به‌ندرت دچار رفتارهای تند یا شتاب‌زده می‌شوند و همواره به دنبال راهی هستند
                        که هم منطقی باشد، هم انسانی و هم آرام.
                    </p>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="سبک عملکرد شما به عنوان یک فرد CIS"
            >
                <div className="text-gray-800 leading-7">
                    <div className="overflow-x-auto">
                        <table className="w-full border border-gray-300 rounded-xl overflow-hidden text-sm">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border border-gray-300 px-4 py-3 text-right">بُعد</th>
                                    <th className="border border-gray-300 px-4 py-3 text-right">ویژگی عملکردی</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-white">
                                    <td className="border border-gray-300 px-4 py-3 font-semibold">C</td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        پیروی از قوانین، بررسی دقیق داده‌ها، دقت در جزئیات
                                    </td>
                                </tr>
                                <tr className="bg-gray-50">
                                    <td className="border border-gray-300 px-4 py-3 font-semibold">I</td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        استفاده از ارتباطات برای تأثیرگذاری، جلب مشارکت و انگیزه‌بخشی
                                    </td>
                                </tr>
                                <tr className="bg-white">
                                    <td className="border border-gray-300 px-4 py-3 font-semibold">S</td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        ثبات رفتاری، حمایت از تیم، وفاداری به روابط
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های درونی"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>
                        گاهی اوقات فرد CIS به دلیل تضاد بین «لطف و ادب» I/S و «نیاز به استاندارد بالا» C،
                        در تصمیم‌گیری‌ها یا اجرای برنامه‌ها دچار کندی می‌شود. مثلاً:
                    </p>

                    <ul className="list-disc pr-6 space-y-2">
                        <li>
                            دلش نمی‌خواهد دیگران ناراحت شوند، ولی اشتباهات دیگران را هم نمی‌تواند تحمل کند.
                        </li>
                        <li>
                            می‌خواهد همه‌چیز عالی پیش برود، اما نمی‌خواهد فضا سنگین و تنش‌زا شود.
                        </li>
                        <li>
                            خودش را مسئول احساسات و موفقیت دیگران می‌داند، و این فشار زیادی به او وارد می‌کند.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فیلم پیشنهادی"
            >
                <p className='text-center text-gray-800 font-bold text-lg'>یافتن فارستر *Finding Forrester 2000*</p>

                <div className='text-gray-800 leading-7'>
                    شخصیت اصلی فیلم، مردی بسیار باهوش، منطقی، دقیق و در عین حال آرام، حامی و انسان‌دوست است. ترکیبی از وجوه رفتاری یک  CIS که هم نظم را حفظ می‌کند، هم الهام‌بخش دیگران است.
                </div>

                <div className='text-gray-800 leading-7'>
                    در مجموع، افراد با تیپ رفتاری  CIS مثل ستون‌های پنهان یک سازمان یا خانواده‌اند. اگر از آن‌ها خوب حمایت شود، می‌توانند پایداری، اخلاق، زیبایی ارتباط و کیفیت را به‌صورت همزمان هدایت کنند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" انگیزه‌های رفتاری افراد با الگوی CIS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>
                        افراد با الگوی CIS به‌طور طبیعی از سه منبع انگیزشی اصلی نیرو می‌گیرند:
                    </p>

                    <ul className="list-disc pr-6 space-y-2">
                        <li>C: دقت و نظم</li>
                        <li>I: تأیید و پذیرش اجتماعی</li>
                        <li>S: احساس مفید بودن و تعلق</li>
                    </ul>

                    <p>
                        این ترکیب منحصربه‌فرد باعث می‌شود افراد CIS با اینکه در ظاهر آرام و متواضع‌اند،
                        در درون انگیزه بالایی برای موفقیت، محبوب بودن و مؤثر بودن داشته باشند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مهم‌ترین محرک‌های انگیزشی CISها"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>افراد با الگوی CIS از این عوامل انگیزشی بیشترین انرژی را می‌گیرند:</p>

                    <ul className="list-disc pr-6 space-y-2">
                        <li>احساس مورد احترام بودن: زمانی که دیگران به دانش، تلاش یا ادب آن‌ها احترام بگذارند، احساس ارزشمندی می‌کنند.</li>
                        <li>ایجاد نظم و کیفیت: وقتی در محیطی هستند که کارها طبق برنامه، دقیق و شفاف پیش می‌رود، روحیه‌شان شکوفا می‌شود.</li>
                        <li>تقدیر و بازخورد مثبت: تشویق محترمانه، نگاه تحسین‌آمیز یا یک جمله دلگرم‌کننده به آن‌ها انرژی زیادی می‌دهد.</li>
                        <li>احساس تعلق به گروه: اگر احساس کنند بخشی از یک تیم باارزش هستند و وجودشان دیده می‌شود، پایداری و تعهد بالایی از خود نشان می‌دهند.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="عوامل کاهش‌دهنده انگیزه"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>افراد با الگوی CIS معمولاً از موارد زیر استقبال نمی‌کنند:</p>

                    <ul className="list-disc pr-6 space-y-2">
                        <li>بی‌نظمی، تصمیم‌گیری‌های هیجانی یا کارهای بدون برنامه</li>
                        <li>انتقادهای مستقیم و تند، خصوصاً در جمع</li>
                        <li>نادیده گرفته شدن تلاش‌ها یا احساس طرد</li>
                        <li>محیط‌هایی که پر از تعارض، رقابت ناسالم یا تغییرات ناگهانی است</li>
                    </ul>

                    <p>
                        <strong>مثال کاربردی:</strong>
                        <br />
                        یک کارمند CIS در تیم بازاریابی، از اینکه پروژه‌ها طبق زمان‌بندی اجرا نمی‌شوند ناراحت می‌شود C،
                        از اینکه نقش زیادی در تصمیم‌گیری ندارد دلگیر است I،
                        و اگر احساس کند به او اعتماد نمی‌شود یا گوش نمی‌دهند، ممکن است کناره‌گیری کند S.
                        اما اگر همین فرد احساس کند نظرش شنیده می‌شود، نتیجه کار ارزش دارد و همکاران قدرش را می‌دانند،
                        با انرژی مضاعف و اشتیاق ادامه می‌دهد.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="عادت‌های کاری شما در تیپ CIS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد دارای تیپ رفتاری  CIS در محیط کاری، منظم، وفادار، انعطاف‌پذیر و در عین حال محتاط هستند. عادات کاری آن‌ها تلفیقی از دقت C، مهربانی و همراهی S، و تعامل مؤثر I  است. آن‌ها دوست دارند هم کار درست انجام شود، هم رابطه خوب حفظ شود.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های شاخص عادات کاری CISها"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div>
                        <strong>برنامه‌ریزی دقیق اما منعطف:</strong>
                        <br />
                        آن‌ها معمولاً با یک برنامه یا چک‌لیست جلو می‌روند، اما اگر ضرورتی پیش آید، تلاش می‌کنند با حفظ احترام، خود را با تغییر هماهنگ کنند.
                    </div>
                    <div>
                        <strong>توجه بالا به جزئیات:</strong>
                        <br />
                        وظایف را با دقت و وسواس خاصی انجام می‌دهند. ممکن است کارشان کمی کند باشد، اما مطمئن هستند کار نهایی باکیفیت است.
                    </div>
                    <div>
                        <strong>درون‌گرا با ارتباطات حرفه‌ای:</strong>
                        <br />
                        با اینکه خیلی اهل شلوغ‌بازی یا نمایش بیرونی نیستند، اما در تیم با ادب، صمیمیت و احترام رفتار می‌کنند و معمولاً قابل‌اعتماد و دوست‌داشتنی هستند.
                    </div>
                    <div>
                        <strong>نیاز به بازخورد ملایم و سازنده:</strong>
                        <br />
                        اگر اشتباهی کنند، زود از درون ناراحت می‌شوند. ولی اگر بازخورد با احترام باشد، آن را به خوبی می‌پذیرند و فوراً اصلاح می‌کنند.
                    </div>
                    <div>
                        <strong>در کارهای گروهی، ستون پنهان تیم‌اند:</strong>
                        <br />
                        شاید کمتر جلو بیایند یا نقش لیدر را بگیرند، اما در هماهنگی، دقت، گزارش‌دهی و ایجاد فضای آرام و سازنده در تیم، نقش حیاتی دارند.
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های احتمالی در محیط کار"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li>سخت‌گیری بیش‌ازحد روی جزئیات ممکن است سرعت عمل را کم کند</li>
                        <li>تمایل به کمال‌گرایی ممکن است منجر به تعلل در تصمیم‌گیری شود</li>
                        <li>ناتوانی در «نه گفتن» ممکن است منجر به فشار کاری زیاد شود</li>
                        <li>در برابر بی‌نظمی یا رفتارهای تند دیگران ممکن است منفعل یا گوشه‌گیر شوند</li>
                    </ul>
                    <div>
                        <strong>مثال کاربردی:</strong><br />
                        فردی با تیپ CIS در واحد منابع انسانی، مسئول تحلیل داده‌های عملکردی کارکنان است. او گزارش‌های دقیق و ساختارمندی تهیه می‌کند C، در جلسات با همکاران با ادب و صمیمیت رفتار می‌کند I، و در رسیدگی به دغدغه‌های کارکنان صبور و پیگیر است S. اگر در چنین محیطی از او قدردانی شود و فضای شفاف و محترمانه‌ای حاکم باشد، با انگیزه بالا به کار ادامه می‌دهد.
                    </div>
                    <div>
                        <strong>پیشنهاد محتوایی:</strong><br />
                        Hidden Figures 2016 ارقام پنهان — فیلمی الهام‌بخش درباره زنانی دقیق، پرتلاش، صبور و در عین حال اجتماعی که با پشتکار، دقت علمی و اعتمادسازی، جایگاه خود را در محیطی مردسالارانه به‌دست می‌آورند.
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دیدگاه‌های شما در تیپ CIS"
            >
                <div className='text-gray-800 leading-7'>
                    فردی با الگوی رفتاری  CIS جهان را با عینک دقت، مهربانی و مقبولیت اجتماعی می‌بیند. دیدگاه‌های او به‌شدت توأم با عقلانیت، مهربانی، و رعایت اصول اخلاقی است. این افراد دنیا را جایگاهی می‌دانند که باید در آن درست رفتار کرد، از دیگران مراقبت کرد، و هم‌زمان مورد پذیرش قرار گرفت.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های کلیدی دیدگاه افراد CIS"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li><strong>نظم و اخلاق دو بال اصلی نگاه آن‌هاست:</strong> بر این باورند که «همه‌چیز باید درست و محترمانه پیش برود». از بی‌برنامگی، نادیده‌گرفتن قوانین یا بی‌احترامی بیزارند.</li>
                        <li><strong>طرفدار صلح، همکاری و اجتناب از تنش‌اند:</strong> در موقعیت‌های اختلاف، ابتدا سعی می‌کنند وساطت کنند یا راهکار منطقی و آرامی ارائه دهند. طرفدار هماهنگی‌اند نه تقابل.</li>
                        <li><strong>جایگاه‌محور اما همراه:</strong> احترام به ساختار، مقام‌ها و وظایف برایشان مهم است، ولی این احترام را با همراهی، نه زور، به‌دست می‌آورند.</li>
                        <li><strong>واقع‌گرا اما ایده‌آل‌طلب:</strong> گاهی نگاه‌شان به جزئیات و روندهای درست، باعث می‌شود برای «وضعیت ایده‌آل» بجنگند، ولی چون نمی‌خواهند ناراحتی ایجاد کنند، خواسته‌شان را نرم و غیرمستقیم مطرح می‌کنند.</li>
                        <li><strong>خودکنترلی بالا و قضاوت بااحتیاط:</strong> به‌راحتی در مورد کسی یا چیزی قضاوت نمی‌کنند. منتظر می‌مانند، بررسی می‌کنند، بعد نظر می‌دهند.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های پنهان دیدگاهی"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li>ممکن است احساساتی بودن دیگران را بی‌منطق تلقی کنند</li>
                        <li>از تغییرات سریع و بدون توضیح، احساس ناامنی و بی‌اعتمادی پیدا کنند</li>
                        <li>اگر در یک جمع شنیده نشوند، دچار حس بی‌ارزشی یا انزوا می‌شوند</li>
                        <li>در محیط‌هایی که در آن دروغ، بی‌اخلاقی یا بی‌نظمی هست، بسیار زود دل‌زده می‌شوند</li>
                    </ul>
                    <p><strong>مثال کاربردی:</strong><br />
                        فرض کنید فرد CIS در تیم کنترل کیفیت یک کارخانه کار می‌کند. وقتی مدیریت تصمیم می‌گیرد بخش‌هایی از فرایند را سریع‌تر و ساده‌تر انجام دهد، او با این دیدگاه مخالفت می‌کند که "این سادگی، ممکنه به کیفیت ضربه بزنه". نه از سر لجبازی، بلکه چون نگران نتیجه بلندمدت است. او تلاش می‌کند نظراتش را مودبانه و مستند بیان کند، اما اگر فضا بسته یا مستعد گوش‌دادن نباشد، ممکن است عقب‌نشینی کند و دیگر ابراز نظر نکند. این در حالی است که اگر فضا، پذیرنده باشد، CISها می‌توانند بهترین تحلیل‌گران و مشاوران تصمیم‌گیری باشند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد فیلم"
            >
                <p className='text-gray-800 text-center text-lg font-bold'>*Bridge of Spies 2015* پل جاسوس ها</p>
                <div className='text-gray-800 leading-7'>
                    شخصیت اصلی وکیل با نقش تام هنکس دقیق، منصف، وفادار، و آرام است. دقیقاً مثل تیپ  CIS . تلاش می‌کند بدون هیاهو و با اخلاق‌مداری، بحران را کنترل کند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="اوقات فراغت در تیپ CIS"
            >
                <div className='text-gray-800 leading-7'>
                    فردی با تیپ رفتاری CIS در اوقات فراغت نیز به‌دنبال آرامش، نظم، تعامل مثبت و رشد فردی است. ترکیب شاخص‌های <strong>C: دقت و تحلیل</strong>، <strong>I: تعامل و شادابی</strong> و <strong>S: وفاداری و آرامش</strong> باعث می‌شود که انتخاب‌های فراغتی این افراد هم متنوع باشد و هم حساب‌شده.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" سبک فراغتی افراد CIS"
            >
                <div className='text-gray-800 space-y-4
                '>
                    <p>
                        <strong>فراغت در محیط‌های آرام، تمیز، با ساختار و هماهنگی:</strong>
                        مانند پارک‌های خلوت، کتابخانه، کوه‌نوردی سبک، طبیعت‌گردی آرام، ساحل، یا نشستن در یک کافه خلوت با دوستان نزدیک.

                    </p>
                    <p>
                        <strong>تعادل بین جمع‌گرایی و خلوت‌طلبی:</strong>
                        دوست دارند در جمع باشند، اما با کسانی که با آن‌ها احساس صمیمیت دارند. مهمانی‌های بزرگ و پر سر و صدا ممکن است آن‌ها را خسته کند. یک دورهمی صمیمی با ۳–۴ دوست صادق، انتخاب ایده‌آل آن‌هاست.

                    </p>
                    <p>                    <strong>اوقات فراغت رشد محور:</strong>
                        خواندن کتاب، یادگیری مهارتی جدید مثل زبان، نرم‌افزار یا موسیقی، یا دیدن مستندها و فیلم‌های تحلیلی برای آن‌ها لذت‌بخش است. تفریح برایشان یعنی «ذهنم هم حال خوبی داشته باشد».
                    </p>
                    <p>                    <strong>تمایل به فعالیت‌های داوطلبانه و مفید:</strong>
                        از حضور در گروه‌های خیریه، پشتیبانی آموزشی یا فعالیت‌های اجتماعی آرام، احساس معنا و رضایت درونی می‌گیرند.
                    </p>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فعالیت‌های مورد علاقه ممکن است شامل شود"
            >
                <div className='text-gray-800 space-y-4'>
                    <ul>
                        <li>کتاب خواندن یا نویسندگی</li>
                        <li>تماشای مستند یا فیلم‌های معناگرا نه اکشن پرهیاهو</li>
                        <li>بازی‌های فکری گروهی یا دو نفره شطرنج، بازی‌های کارتی استراتژیک</li>
                        <li>گشت‌وگذار در طبیعت</li>
                        <li>آشپزی خلاقانه</li>
                        <li>کار داوطلبانه یا فعالیت‌های اجتماعی حمایتی</li>
                        <li>یادگیری مهارت از طریق دوره‌های آنلاین در فضای شخصی</li>
                    </ul>

                    <p>
                        <strong>مثال کاربردی:</strong><br />
                        فرض کنید یک خانم CIS آخر هفته خود را این‌طور برنامه‌ریزی کرده:
                    </p>

                    <ul>
                        <li>صبح با خانواده در طبیعت خلوت پیاده‌روی می‌کند S</li>
                        <li>بعدازظهر یک فیلم مستند اجتماعی می‌بیند و خلاصه‌ای از آن را برای گروه دوستانش می‌فرستد C</li>
                        <li>شب در یک جمع دوستانه کوچک حضور دارد، با کسانی که می‌داند حرف‌هایش را درک می‌کنند و فضا پر از احترام و همدلی است I + S</li>
                    </ul>

                    <p>
                        او با این سبک آرام، منظم و معنادار شارژ می‌شود و برای هفته آینده آماده‌تر خواهد بود.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" پیشنهاد محتوایی"
            >
                <p className='text-gray-800 text-center text-lg font-bold'>Julie & Julia 2009</p>

                <div className='text-gray-800 leading-7'>
                    فیلمی درباره دو زن با تیپ‌های رفتاری متفاوت؛ یکی دقیق، مسئولیت‌پذیر، درون‌گرا و اهل نوشتن  CIS نمونه! که تلاش می‌کند در مسیر کاری و شخصی‌اش با پختن غذا و نوشتن درباره آن، معنا پیدا کند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تصمیم‌گیری در تیپ CIS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>
                        فرد با الگوی رفتاری CIS تصمیم‌گیرنده‌ای تحلیل‌گر، محتاط، و هماهنگ‌محور است. او ترجیح می‌دهد تصمیماتش هم منطقی باشد C، هم به دل دیگران بنشیند I، و هم کمترین تنش و بی‌نظمی ایجاد کند S.
                    </p>

                    <ul className='list-disc pl-6 space-y-2'>
                        <li>
                            <strong>کند، دقیق، بررسی‌گر:</strong> افراد CIS به‌راحتی وارد تصمیم‌گیری‌های سریع یا هیجانی نمی‌شوند. ترجیح می‌دهند ابتدا اطلاعات را کامل، منابع را شفاف، و نتایج احتمالی را پیش‌بینی کنند. حتی اگر تصمیم ساده‌ای باشد، آن را در ذهنشان تحلیل می‌کنند.
                        </li>
                        <li>
                            <strong>تحت‌تأثیر محیط انسانی:</strong> دیدگاه‌ها و احساسات دیگران در تصمیم‌گیری آن‌ها تأثیر دارد. ممکن است به‌خاطر ناراحت‌نشدن دیگران، تصمیمی بگیرند که خودشان با آن موافق کامل نیستند.
                        </li>
                        <li>
                            <strong>تمایل به اجماع و هماهنگی:</strong> اگر تصمیم گروهی باشد، ترجیح می‌دهند همه راضی باشند. گاهی این باعث عقب‌افتادن تصمیم یا تعویق زیاد در اجرای آن می‌شود.
                        </li>
                        <li>
                            <strong>در برابر تصمیمات احساسی مقاومت دارند:</strong> برای افراد CIS خیلی سخت است که فقط با دل پیش بروند؛ آن‌ها نیاز دارند دلایل، منطق و داده‌ها نیز کنار احساس باشند.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های رایج"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='list-decimal pl-6 space-y-2'>
                        <li>
                            <strong>کمال‌گرایی در تصمیم‌گیری:</strong> گاهی تا زمانی که ۱۰۰٪ از صحت تصمیم مطمئن نشوند، اقدام نمی‌کنند.
                        </li>
                        <li>
                            <strong>ترس از اشتباه و ارزیابی دیگران:</strong> نگرانی از قضاوت دیگران می‌تواند قدرت تصمیم‌گیری را کاهش دهد.
                        </li>
                        <li>
                            <strong>وابستگی به تأیید اجتماعی:</strong> ممکن است تصمیم را وابسته به تأیید دیگران کنند و استقلال تصمیم‌گیری کاهش یابد.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" راهکارهای بهبود تصمیم‌گیری"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='list-decimal pl-6 space-y-2'>
                        <li>
                            <strong>تمرین تصمیم‌گیری در زمان محدود:</strong> برای شروع، تصمیم‌های کوچک را با زمان‌سنجی بگیرید، مثلاً «تا ۱۰ دقیقه آینده انتخاب می‌کنم».
                        </li>
                        <li>
                            <strong>محدودکردن گزینه‌ها:</strong> در انتخاب‌هایی که بین چند گزینه هستند، ۲ تا از آن‌ها را حذف کنید تا بار تصمیم‌گیری سبک‌تر شود.
                        </li>
                        <li>
                            <strong>مشورت هدفمند:</strong> با افراد قاطع و منطقی، مثلاً تیپ‌های D یا DC مشورت کنید.
                        </li>
                        <li>
                            <strong>نوشتن جوانب مثبت و منفی:</strong> جوانب را روی کاغذ بیاورید؛ این کار ذهن را از حالت مبهم خارج می‌کند.
                        </li>
                        <li>
                            <strong>پذیرفتن اصل "تصمیم کامل وجود ندارد":</strong> همیشه بخشی از عدم‌قطعیت در تصمیم‌ها هست و این طبیعی است.
                        </li>
                    </ul>

                    <p>
                        <strong>مثال کاربردی:</strong><br />
                        در محیط کاری، فرد CIS قرار است بین دو پیشنهاد شغلی یکی را انتخاب کند. او شروع به جدول‌سازی می‌کند: حقوق، مسیر رفت‌وآمد، فرهنگ سازمانی، تعامل با تیم و...
                        در کنار این موارد، می‌پرسد آیا در شرکت جدید، روابط صمیمانه‌ای مثل محیط فعلی شکل خواهد گرفت یا نه؟
                        اگر تیم پشتیبانی مناسبی نداشته باشد، حتی با درآمد بیشتر، احتمالاً پیشنهاد را رد می‌کند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادات جهت بهبود عملکرد CIS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>
                        افراد با الگوی CIS معمولاً دقیق، آرام، وفادار و دارای روحیه همدلی بالا هستند. آن‌ها در ایجاد نظم، پشتیبانی از دیگران و تحلیل مسائل عملکرد خوبی دارند. اما برای افزایش اثربخشی در زندگی حرفه‌ای و شخصی، لازم است بعضی ویژگی‌های رفتاری خود را توسعه دهند و برخی را تعدیل کنند.
                    </p>

                    <ul className='list-decimal pl-6 space-y-2'>
                        <li>
                            <strong>از منطقه امن خود آگاهانه خارج شوید:</strong> شما تمایل زیادی به حفظ ثبات، آرامش و روابط بدون تنش دارید. اما این موضوع گاهی مانع تصمیمات جسورانه یا ورود به موقعیت‌های چالش‌برانگیز می‌شود.
                            <br />
                            <strong>راهکار:</strong>
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>هر ماه یک کار خارج از «کادر رفتاری‌تان» انجام دهید، مثل ارائه در جمع، شروع یک گفتگوی سخت، یا تجربه کاری جدید.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>به تصمیم‌گیری شفاف و سریع‌تر عادت کنید:</strong> بیش‌تحلیلی، کمال‌گرایی و تمایل به تأیید همگان می‌تواند عملکرد شما را کند کند یا فرصت‌ها را از بین ببرد.
                            <br />
                            <strong>راهکار:</strong>
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>زمان‌دار تصمیم بگیرید، مثلاً "در ۲۴ ساعت آینده تصمیمم را می‌گیرم".</li>
                                <li>به خودتان بگویید: "نیازی نیست تصمیم بی‌نقص باشد؛ تصمیم خوب کافی است."</li>
                            </ul>
                        </li>

                        <li>
                            <strong>ابراز احساسات را تمرین کنید:</strong> شما ممکن است به دلیل ادب، احتیاط یا ترس از ناراحت‌کردن دیگران، احساسات واقعی‌تان را بیان نکنید.
                            <br />
                            <strong>راهکار:</strong>
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>در محیط‌های امن و صمیمی مثل خانواده یا دوستان نزدیک، احساسات خود را بیان کنید، حتی اگر متفاوت باشند.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>شفافیت خواسته‌ها را در روابط افزایش دهید:</strong> شما گاهی خواسته‌های خود را قربانی هماهنگی یا رضایت دیگران می‌کنید و سپس در دل خود رنج می‌برید.
                            <br />
                            <strong>راهکار:</strong>
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>قبل از موافقت با هر خواسته‌ای از دیگران بپرسید: "آیا واقعاً می‌خواهم این کار را انجام دهم؟ آیا زمان و انرژی آن را دارم؟"</li>
                            </ul>
                        </li>

                    </ul>

                </div>
            </Page>

            <Page
                testResult={testResult}
            >
                <div className='text-gray-800 space-y-4'>
                    <ul>
                        <li>
                            <strong>خودانتقادی را به خودآگاهی تبدیل کنید:</strong> افراد CIS گاهی آن‌قدر بر خودشان سخت‌گیرند که دچار اضطراب، فرسودگی یا کاهش اعتمادبه‌نفس می‌شوند.
                            <br />
                            <strong>راهکار:</strong>
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>هر هفته ۳ نقطه قوت خود را بنویسید و یک مورد را با صدای بلند برای خود بخوانید.</li>
                                <li>از اشتباهات درس بگیرید اما در آن‌ها غرق نشوید.</li>
                            </ul>
                        </li>
                    </ul>

                    <p>
                        <strong>مثال کاربردی:</strong><br />
                        فرض کنید شما مسئول پیگیری پروژه‌ای هستید، اما اعضای تیم وظایفشان را به‌موقع تحویل نمی‌دهند.
                        شما درون خود ناراحت هستید اما مستقیماً چیزی نمی‌گویید تا مبادا به کسی بربخورد.
                        در نتیجه پروژه به تأخیر می‌افتد و شما احساس فشار بیشتری می‌کنید.
                        پیشنهاد: جلسه‌ای کوتاه و دوستانه با اعضا بگذارید، ضمن حفظ احترام، با صراحت درباره تاخیرها صحبت کنید و ضرب‌الاجل جدید را تعیین نمایید.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="رمز موفقیت در تیپ CIS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p>
                        رمز موفقیت برای تیپ‌های CIS در یافتن تعادل بین دقت، همدلی و ثبات است؛ اگر این تعادل با قاطعیت، سرعت عمل و بیان مؤثر خواسته‌ها همراه شود، افراد CIS می‌توانند در محیط‌های کاری، خانوادگی و اجتماعی عملکردی درخشان داشته باشند.
                    </p>

                    <ul className='list-decimal pl-6 space-y-2'>
                        <li>
                            <strong>ترکیب دقت + همدلی + بیان احساسات:</strong>
                            شما ذاتاً انسان دقیقی هستید که در روابط انسانی نیز مهارت خوبی دارید. اما اگر این ویژگی‌ها را با «بیان شفاف خواسته‌ها» و «جسارت کلامی» همراه نکنید، دیگران ممکن است شما را نادیده بگیرند یا مسئولیت‌های بیش از حد به دوش شما بیفتد.
                            موفقیت اینجاست که:
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>به‌موقع «نه» بگویید.</li>
                                <li>احساسات واقعی خود را بیان کنید.</li>
                                <li>و همچنان همدل بمانید.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>متعادل کردن "کمال‌گرایی":</strong>
                            کمال‌گرایی شما باعث می‌شود همیشه بهترین کیفیت را بخواهید، اما گاهی این موضوع باعث تعویق یا اضطراب می‌شود.
                            موفقیت اینجاست که یاد بگیرید:
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>کار خیلی خوب بهتر از کار بی‌نقصِ انجام‌نشده است.</li>
                                <li>پیشرفت مهم‌تر از کامل‌بودن است.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>پذیرش تغییرات و مواجهه با چالش‌ها:</strong>
                            شما از بی‌نظمی و بی‌ثباتی دل خوشی ندارید، اما موفقیت در دنیای امروز مستلزم پذیرش تغییرات و گاهی حرکت در فضای خاکستری است.
                            رمز موفقیت این است که:
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>به تغییرات به چشم «فرصت یادگیری» نگاه کنید.</li>
                                <li>هر تغییر، تهدید نیست؛ بعضی تغییرها در را به سوی توانمندی‌های نهفته شما باز می‌کنند.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>حفظ سلامت روانی و هیجانی:</strong>
                            از آنجایی که شما شنونده خوبی هستید و اغلب نقش «حامی» را دارید، باید مراقب فرسودگی احساسی باشید.
                            راهکار:
                            <ul className='list-disc pl-6 space-y-1'>
                                <li>به نیازهای هیجانی خود توجه کنید.</li>
                                <li>زمانی برای «خود بودن» در نظر بگیرید.</li>
                                <li>ارتباطات با افرادی که شما را تغذیه روحی می‌کنند حفظ کنید.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" خلاصه رموز موفقیت برای CIS"
            >
                <div className='text-gray-800 leading-7'>
                    <table className='w-full border border-gray-300 text-right'>
                        <thead>
                            <tr className='bg-gray-100'>
                                <th className='border border-gray-300 px-4 py-2'>توضیح</th>
                                <th className='border border-gray-300 px-4 py-2'>رمز</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>حمایت از دیگران تا زمانی مفید است که خودت را قربانی نکنی.</td>
                                <td className='border border-gray-300 px-4 py-2'>خوب گوش بده، اما خودت را فراموش نکن.</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>از خودت دفاع کن؛ مودب اما قاطع.</td>
                                <td className='border border-gray-300 px-4 py-2'>برای خواسته‌هایت ایستادگی کن.</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>فقط دانستن کافی نیست، اجرا کردن مهم است.</td>
                                <td className='border border-gray-300 px-4 py-2'>تحلیل را با اقدام ترکیب کن.</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>هر بار یک گام کوچک در مسیر جدید.</td>
                                <td className='border border-gray-300 px-4 py-2'>تغییر را تمرین کن.</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>همدل باش، اما قضاوتت را هم روشن نگه دار.</td>
                                <td className='border border-gray-300 px-4 py-2'>تعادل بین حس و منطق</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نحوه تعدیل و تقویت لایه‌های رفتاری در تیپ CIS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد با تیپ CIS معمولاً در سه ویژگی اصلی برجسته‌اند:
                    دقت C، ثبات S و همدلی و تعامل I در حد پایین‌تر. برای دستیابی به عملکرد بالاتر، باید برخی لایه‌ها را تعدیل و برخی را تقویت کنند.
                    در این بخش، به شما کمک می‌کنیم که:
                    <ul className='list-disc mr-6 space-y-2'>
                        <li>ویژگی‌های درونی خود را بهتر مدیریت کنید</li>
                        <li>لایه‌های دیگر مدل DISC را متناسب با نیازهایتان تقویت یا متعادل کنید</li>
                        <li>در تعاملات شخصی، کاری و اجتماعی مؤثرتر شوید</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تقویت لایه D در تیپ CIS: یادگیری جسارت، تصمیم‌گیری سریع و اقتدار"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p><strong>چرا لازم است؟</strong> زیرا شما گاهی به خاطر احتیاط زیاد، فرصت‌های مهم را از دست می‌دهید یا در برابر فشارهای بیرونی به‌جای ایستادگی، عقب‌نشینی می‌کنید.</p>
                    <p><strong>راهکارها:</strong></p>
                    <ul className='list-disc mr-6 space-y-2'>
                        <li>از جملاتی مثل "من انتخاب می‌کنم..." به‌جای "امکانش هست..." استفاده کنید.</li>
                        <li>تمرین روزانه در تصمیم‌گیری‌های کوچک: مثل انتخاب مسیر، رستوران یا زمان استراحت.</li>
                        <li>در جلسه‌ها، حتی اگر مطمئن نیستید، یک پیشنهاد بدهید. تمرین جسارت کنید.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تقویت لایه I: بیان احساسات، شروع ارتباط، دیده شدن"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p><strong>چرا لازم است؟</strong> چون شما بیشتر درون‌نگر و مایل به حفظ فاصله هستید. این ویژگی، شما را از فرصت‌های شبکه‌سازی، تعامل اجتماعی و حتی ترفیع شغلی دور می‌کند.</p>
                    <p><strong>راهکارها:</strong></p>
                    <ul className='list-disc mr-6 space-y-2'>
                        <li>هر هفته با یک نفر تماس بگیرید یا حضوری احوالپرسی کنید.</li>
                        <li>در جمع‌های کوچک، سعی کنید شروع‌کننده گفت‌وگو باشید.</li>
                        <li>احساستان را در یک جمله کوتاه بیان کنید: "من الان خوشحالم"، "از حرفت ناراحت شدم" و...</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تعدیل ویژگی‌های بیش‌فعالشده S و C: زیاده‌روی در وفاداری، نظم و احتیاط"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <p><strong>چرا لازم است؟</strong> زیرا شما ممکن است در نتیجه کمال‌گرایی یا محافظه‌کاری بیش‌ازحد، دچار تصمیم‌گریزی، اضطراب یا نارضایتی شوید.</p>
                    <p><strong>توصیه‌ها:</strong></p>
                    <ul className='list-disc mr-6 space-y-2'>
                        <li>از جمله‌های تعدیل‌گر استفاده کنید: "الان کافی هست، نیازی به بازبینی چهارم نیست."، "می‌پذیرم ممکنه همه خوشحال نشن، ولی تصمیمم رو می‌گیرم."</li>
                        <li>برای نظم بیش‌ازحد: یک روز در هفته را بدون برنامه‌ریزی رها کنید.</li>
                        <li>برای وفاداری بی‌مرز: محدوده کمک را مشخص کنید. به جای "همیشه در خدمت‌تونم"، بگویید: "اگر تا سه‌شنبه نیاز داشتید، درخدمتم."</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="جملات تعدیل و تقویت پیشنهادی قابل استفاده در گفت‌وگوهای خودآگاه"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>«ریسک کنترل‌شده، یک فرصت برای رشد است.»</li>
                        <li>«من نیاز دارم خواسته‌ام را واضح‌تر بگویم.»</li>
                        <li>«هر کس مسئول احساسات خودش است، من فقط می‌توانم همدل باشم، نه ناجی.»</li>
                        <li>«گاهی وقت‌ها خوب بودن کافی است، لازم نیست عالی باشد.»</li>
                        <li>«من هم مهمم. خواسته‌ام را بیان می‌کنم.»</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دانش و مهارت‌های مورد نیاز الگوی CIS"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p>
                        افراد با تیپ رفتاری CIS ترکیبی از ویژگی‌های تحلیل‌گر بودن C، همدل و آرام بودن S و مقداری اجتماعی‌بودن I دارند.
                        برای توسعه شخصی و حرفه‌ای این افراد، تمرکز بر مهارت‌هایی ضروری است که آن‌ها را از "محتاطِ دقیقِ ساکت" به "تحلیل‌گر متأثر و اثرگذار" تبدیل کند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="1. مهارت‌های تصمیم‌گیری سریع"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p>
                        افراد CIS در تصمیم‌گیری دچار تعلل می‌شوند، زیرا هم می‌خواهند همه‌چیز دقیق و کامل باشد C و هم نگران احساسات و روابط هستند S.
                    </p>
                    <p><strong>باید بیاموزند:</strong></p>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>چطور در زمان محدود، با اطلاعات ناقص، تصمیمی مفید بگیرند.</li>
                        <li>فرق بین تصمیم‌های مهم و کم‌اهمیت را تشخیص دهند و برای هرکدام زمان متناسب بگذارند.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="2. هوش هیجانی و جرأت‌مندی ارتباطی"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p>
                        افراد CIS معمولاً بیش از حد محتاط‌اند، گاهی خواسته‌های خود را بیان نمی‌کنند، و ممکن است مورد سوءاستفاده عاطفی یا کاری قرار گیرند.
                    </p>
                    <p><strong>نیازمند تقویت:</strong></p>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>مهارت نه گفتن با احترام</li>
                        <li>بیان احساسات بدون ترس از رد شدن</li>
                        <li>درخواست کردن بدون احساس گناه</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="3. مهارت‌های ارائه و سخنرانی"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p>
                        این افراد گاهی ایده‌های بسیار خوبی دارند اما نمی‌توانند آن‌ها را در جلسات یا جمع‌ها به‌درستی منتقل کنند.
                    </p>
                    <p><strong>آموزش لازم دارند برای:</strong></p>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>تنظیم ساختار حرفه‌ای سخنرانی</li>
                        <li>کنترل ترس از جمع</li>
                        <li>استفاده از زبان بدن و لحن مؤثر</li>
                    </ul>
                    <p>
                        فیلم پیشنهادی: <strong>Finding Forrester</strong>
                        یک نوجوان باهوش، ساکت و منزوی با راهنمایی یک استاد نویسندگی، یاد می‌گیرد صدای خود را پیدا کند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="4. مهارت‌های تفکر انتقادی و حل مسئله"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p>
                        CISها در تحلیل اطلاعات قوی هستند، اما گاهی در تصمیم‌سازی یا اولویت‌بندی مشکل دارند.
                    </p>
                    <p><strong>بهتر است بیاموزند:</strong></p>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>از مدل‌هایی مثل SWOT، 5 Why و مدل حل مسئله Kepner-Tregoe استفاده کنند.</li>
                        <li>تصمیمات را به زبان ساده با دیگران به اشتراک بگذارند و لایه I خود را تقویت کنند.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="5. مهارت‌های مربوط به مدیریت زمان و انرژی"
            >
                <div className='text-gray-800 leading-7 space-y-2'>
                    <p><strong>تمرین برای:</strong></p>
                    <ul className='list-disc mr-6 space-y-1'>
                        <li>اولویت‌بندی وظایف</li>
                        <li>تعیین مرز برای کار بیش از حد و نه گفتن به درخواست‌های اضافی</li>
                        <li>در نظر گرفتن زمانی برای خودمراقبتی</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="جدول مهارت‌های کلیدی برای تیپ CIS"
            >
                <div className='text-gray-800 leading-7'>
                    <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                        <thead>
                            <tr className='bg-gray-100'>
                                <th className='border border-gray-300 px-4 py-2'>دسته مهارتی</th>
                                <th className='border border-gray-300 px-4 py-2'>توضیحات اصلی</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>مهارت نه گفتن</td>
                                <td className='border border-gray-300 px-4 py-2'>تقویت جرأت کلامی و حفظ مرزها بدون آسیب به رابطه</td>
                            </tr>
                            <tr className='bg-gray-50'>
                                <td className='border border-gray-300 px-4 py-2'>تفکر انتقادی</td>
                                <td className='border border-gray-300 px-4 py-2'>بررسی اطلاعات از منظر استراتژیک و اولویت‌دار</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>بیان احساسات</td>
                                <td className='border border-gray-300 px-4 py-2'>تبدیل احساس به کلام صریح ولی محترمانه</td>
                            </tr>
                            <tr className='bg-gray-50'>
                                <td className='border border-gray-300 px-4 py-2'>تصمیم‌گیری سریع</td>
                                <td className='border border-gray-300 px-4 py-2'>تمرین اقدام در زمان‌های نامطمئن یا با اطلاعات ناقص</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>ارائه و سخنوری</td>
                                <td className='border border-gray-300 px-4 py-2'>توان بیان شفاف ایده‌ها، کنترل اضطراب، جذب مخاطب</td>
                            </tr>
                            <tr className='bg-gray-50'>
                                <td className='border border-gray-300 px-4 py-2'>مدیریت روابط</td>
                                <td className='border border-gray-300 px-4 py-2'>حفظ مرز با اطرافیان، نه از موضع ضعف بلکه از موضع سلامت</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>خودمراقبتی هیجانی</td>
                                <td className='border border-gray-300 px-4 py-2'>استراحت، بازیابی، شناخت نشانه‌های فرسودگی احساسی</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی     CIS
"
            >
                <div className='text-gray-800 leading-7'>
                    الگوی CIS ترکیبی از ویژگی‌های دقیق‌گرایی C، صبوری و حمایت‌گری S و ارتباط‌پذیری ملایم I است. افراد دارای این الگو معمولاً:

                    <ul className='list-disc pl-6 space-y-2'>
                        <li>به دقت و کیفیت اهمیت زیادی می‌دهند</li>
                        <li>دوست دارند در آرامش و نظم کار کنند</li>
                        <li>روابط انسانی و فضای همکاری و همدلی برایشان مهم است</li>
                        <li>تمایل به کنترل در پشت صحنه دارند و معمولاً جلوه‌گری زیادی ندارند</li>
                    </ul>

                    در انتخاب شغل برای افراد با این تیپ رفتاری، باید شغل‌هایی مدنظر قرار گیرد که در آن‌ها:

                    <ul className='list-disc pl-6 space-y-2'>
                        <li>دقت و تحلیل‌گری موردنیاز باشد</li>
                        <li>کار تیمی همراه با هماهنگی بالا وجود داشته باشد</li>
                        <li>امکان پیش‌بینی نسبی امور و ثبات شغلی فراهم باشد</li>
                        <li>فضای کاری امن و حمایتگرانه باشد</li>
                    </ul>

                    <ul className='list-disc pl-6 space-y-2'>
                        <li><strong>تحلیل‌گر داده / داده‌پرداز:</strong> با توجه به دقت، نظم و علاقه به ساختار، افراد CIS می‌توانند داده‌ها را با دقت تحلیل کرده و گزارش‌های دقیق تولید کنند.</li>
                        <li><strong>مشاور منابع انسانی:</strong> فضای حمایتی، توجه به روابط بین فردی و علاقه به بهبود فرآیندها، این تیپ را برای نقش‌های منابع انسانی بسیار مناسب می‌کند.</li>
                        <li><strong>درمانگر / روان‌شناس بالینی یا مشاور خانواده:</strong> ترکیب گوش دادن عمیق S، تحلیل‌گری C و همدلی I این افراد را به مشاورانی بی‌نظیر تبدیل می‌کند.</li>
                        <li><strong>کتابدار یا مسئول آرشیو دیجیتال:</strong> نظم، دقت و علاقه به ساختارهای اطلاعاتی برای این شغل ضروری است و با روحیه درون‌گرای CIS هماهنگ است.</li>
                        <li><strong>طراح آموزشی / برنامه‌ریز درسی:</strong> این افراد با دقت بالا، محتوای آموزشی ساختارمند و کاربردی طراحی می‌کنند و به نیازهای فراگیران نیز توجه دارند.</li>
                        <li><strong>کارشناس امور قراردادها و امور حقوقی داخلی:</strong> توانایی پیگیری دقیق جزئیات و تفسیر متن‌های حقوقی بلند با تمرکز بالا از ویژگی‌های افراد CIS است.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <ul className='list-disc pl-6 space-y-2 text-gray-800 leading-7'>
                    <li><strong>پژوهشگر دانشگاهی یا آزمایشگاهی:</strong> فضای باثبات، پژوهش‌های عمیق، مستندسازی و کار فردی منظم، کاملاً برای تیپ CIS مناسب است.</li>
                    <li><strong>کارشناس کنترل کیفیت / ممیز سیستم‌ها ISO/QA:</strong> افراد CIS می‌توانند استانداردها را با وسواس مثبت اجرا کنند و ناظرانی منظم، دقیق و خوش‌برخورد باشند.</li>
                    <li><strong>متخصص گفتاردرمانی یا توانبخشی:</strong> نیازمند صبر، حمایت، دقت و ارتباط مؤثر با افراد آسیب‌پذیر است؛ شرایط ایده‌آل برای تیپ CIS.</li>
                    <li><strong>مدیر برنامه‌ریزی و بودجه‌ریزی آموزشی / مالی:</strong> اگرچه به جای تصمیمات سریع، افراد CIS تصمیمات سنجیده و دقیق می‌گیرند، اما در تحلیل سناریوها و طراحی ساختارها عالی‌اند.</li>
                </ul>
            </Page>


            <Page
                testResult={testResult}
                title="ویژگی‌های مشترک مشاغل مناسب برای CISها"
            >
                <div className='text-gray-800 leading-7 overflow-x-auto'>
                    <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                        <thead>
                            <tr className='bg-gray-100'>
                                <th className='border border-gray-300 px-4 py-2'>مشاغل</th>
                                <th className='border border-gray-300 px-4 py-2'>چالش اصلی برای CIS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>فروشندگی رقابتی یا مشاغل فشار محور</td>
                                <td className='border border-gray-300 px-4 py-2'>فشار کاری بالا و نیاز به تصمیم‌گیری سریع</td>
                            </tr>
                            <tr className='bg-gray-50'>
                                <td className='border border-gray-300 px-4 py-2'>سرعت تصمیم‌گیری بالا / ریسک‌پذیری زیاد</td>
                                <td className='border border-gray-300 px-4 py-2'>تصمیم‌گیری فوری بدون فرصت تحلیل کامل</td>
                            </tr>
                            <tr>
                                <td className='border border-gray-300 px-4 py-2'>کارهای پرتحرک و تعامل سطحی</td>
                                <td className='border border-gray-300 px-4 py-2'>ارتباط سطحی و سریع با افراد متعدد که ممکن است باعث خستگی شود</td>
                            </tr>
                            <tr className='bg-gray-50'>
                                <td className='border border-gray-300 px-4 py-2'>مدیریت پرتنش با وظایف فوری</td>
                                <td className='border border-gray-300 px-4 py-2'>مدیریت تنش و برخورد با عواقب فوری که برای CIS سنگین است</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغلی که ممکن است برای CISها چالش‌برانگیز باشد"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc list-inside space-y-2'>
                        <li>فروشندگی رقابتی یا مشاغل فشار محور مثل بازاریاب تلفنی</li>
                        <li>شغل‌هایی با سرعت تصمیم‌گیری بالا، ریسک‌پذیری زیاد یا ابهام زیاد</li>
                        <li>کارهای پرتحرک، پر از تعامل سطحی یا پرفشار عاطفی</li>
                        <li>مشاغل مدیریتی پرتنش با وظیفه اخراج، تنبیه یا پیگیری لحظه‌ای نتایج</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="همسر مناسب و نحوه ارتباط مؤثر با او"
            >
                <div className='text-gray-800 leading-7'>
                    فرد با تیپ CIS ترکیبی از سه ویژگی رفتاری دارد:
                    <ul className='list-disc mr-6 mt-2 space-y-2'>
                        <li><strong>C – مطابق‌سازی:</strong> علاقه‌مند به دقت، تحلیل، ساختار و قوانین.</li>
                        <li><strong>I – تأثیرگذاری ملایم:</strong> نیازمند تأیید اجتماعی، ارتباط‌پذیر و مشتاق به برقراری رابطه صمیمانه.</li>
                        <li><strong>S – ثبات:</strong> آرام، حمایت‌گر، صبور و ترجیح‌دهنده محیط پایدار و قابل پیش‌بینی.</li>
                    </ul>
                    این فرد معمولاً آرام، بااحساس، تحلیل‌گر و شنونده‌ای قوی است؛ بنابراین در رابطه عاطفی به دنبال امنیت، صداقت، وفاداری و ارتباط محترمانه می‌گردد.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های مناسب همسر فرد CIS"
            >
                <div className='text-gray-800 leading-7'>
                    <ol className='list-decimal mr-6 mt-2 space-y-2'>
                        <li><strong>صبور و حمایت‌گر باشد:</strong> چون فرد CIS معمولاً کندتر از دیگران برای اعتماد یا تصمیم‌گیری پیش می‌رود و به حمایت درونی و کلامی نیاز دارد.</li>
                        <li><strong>احترام به حریم شخصی را درک کند:</strong> او فضای خصوصی‌اش را دوست دارد و ترجیح می‌دهد در زمان‌هایی با خودش تنها باشد یا در سکوت فکر کند.</li>
                        <li><strong>قابل اعتماد و منطقی باشد:</strong> فرد CIS از هیجانات ناگهانی، دروغ یا تغییرات غیرمنتظره بیزار است و نیاز دارد همسرش قابل پیش‌بینی و ریشه‌دار باشد.</li>
                        <li><strong>در بیان احساسات به او کمک کند:</strong> چون معمولاً احساساتش را به راحتی بروز نمی‌دهد و ممکن است به تشویق برای صحبت از احساس نیاز داشته باشد.</li>
                        <li><strong>توانایی قدردانی از او:</strong> تلاش‌های پشت‌پرده او، نظم، مراقبت و حمایتش باید دیده و تشویق شود.</li>
                    </ol>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که همسر فرد CIS باید بداند"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc mr-6 mt-2 space-y-2'>
                        <li>نیاز به تأیید و قدردانی دارد، حتی اگر خودش نگوید.</li>
                        <li>در مواقع بحران به‌جای فشار، با احترام و آرامش فضایی برای تحلیل و جمع‌بندی به او بدهید.</li>
                        <li>هرگز در جمع او را نقد نکنید یا غافلگیر نکنید.</li>
                        <li>اگر دیر تصمیم می‌گیرد، به او فرصت بررسی بدهید، اما کمکش کنید وارد عمل شود.</li>
                        <li>نیازمند برنامه، هدف روشن و ساختار مشخص است؛ ابهام زیاد او را مضطرب می‌کند.</li>
                        <li>علاقه‌مند به گفت‌وگوهای با معناست، نه مکالمات سطحی و کوتاه.</li>
                        <li>او نسبت به بی‌نظمی یا بی‌دقتی واکنش منفی نشان می‌دهد، پس بهتر است شریک زندگی‌اش نیز به نظم توجه کند.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که فرد باید در زندگی زناشویی رعایت کند"
            >
                <div className='text-gray-800 leading-7'>
                    <ol className='list-decimal mr-6 mt-2 space-y-2'>
                        <li>احساساتت را پنهان نکن؛ شفاف‌سازی احساس امنیت می‌آورد.</li>
                        <li>گاهی لازم است سریع‌تر تصمیم بگیری و از بیش‌تحلیل کردن بپرهیزی.</li>
                        <li>از موقعیت‌های احساسی نگریز؛ گفت‌وگوی عاطفی را تمرین کن.</li>
                        <li>در برابر هیجان یا خشم طرف مقابل، به جای سکوت مطلق، ابراز نظر کن.</li>
                        <li>به یاد داشته باش که کمال‌گرایی تو نباید مانع انعطاف در زندگی شود.</li>
                        <li>گاهی اجازه بده بدون برنامه‌ریزی دقیق هم لحظه‌ای از زندگی لذت ببری.</li>
                        <li>همسرت را هم در برنامه‌هایت سهیم کن؛ کار تیمی حتی در روابط دو نفره هم مهم است.</li>
                    </ol>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فیلم پیشنهادی"
            >
                <div className='text-gray-800 leading-7'>
                    فیلم <strong>The King's Speech</strong> رابطه بین شاه جورج ششم که تیپ رفتاری CIS دارد (تحلیل‌گر، خجالتی، محافظه‌کار) و همسرش بسیار آموزنده است. همسرش با درک بالا، به او کمک می‌کند اعتماد به نفس و خودابرازی پیدا کند.
                </div>
            </Page>
            <Page
                testResult={testResult}
                title="ارتباط مؤثر والدین CIS با فرزندان و بالعکس"
            >
                <div className='text-gray-800 leading-7'>
                    والدینی با الگوی رفتاری CIS معمولاً منطقی، دقیق، آرام، حمایت‌گر و تحلیل‌گر هستند.
                    آن‌ها تمایل دارند والدینی وظیفه‌شناس و مسئولیت‌پذیر باشند و برای فرزندان خود:
                    <ul className='list-disc mr-6 mt-2 space-y-2'>
                        <li>ساختاری روشن و محیطی امن تعریف کنند</li>
                        <li>انتظارات مشخص داشته باشند</li>
                    </ul>
                    ممکن است در ابراز هیجانات، انعطاف در رفتار و تحمل آشفتگی‌های کودکانه دچار چالش شوند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ارتباط مؤثر CIS با فرزندان"
            >
                <div className='text-gray-800 leading-7'>
                    <ol className='list-decimal mr-6 mt-2 space-y-2'>
                        <li><strong>احساسات را بشناسید و بروز دهید:</strong> والد CIS معمولاً تحلیل‌گر است و ابراز عاطفه‌اش در عمل نهفته (مثل کمک در درس، نظم دادن به امور). به کودک بگویید: «دوستت دارم»، «بهت افتخار می‌کنم»، «ناراحتت کردم؟ بیا حرف بزنیم.»</li>
                        <li><strong>فاصله عاطفی ایجاد نکنید:</strong> زمان مشخصی برای گفت‌وگوی آزاد و بدون تحلیل صرف کنید تا فرزند احساس کند جایگاهش محفوظ است.</li>
                        <li><strong>بیش‌تحلیل نکنید، بیشتر گوش بدهید:</strong> وقتی فرزند با هیجان یا ترس می‌آید، ابتدا احساسش را بشنوید.
                            ❌ نگو: «این که چیزی نیست!»
                            ✅ بگو: «می‌فهمم که ناراحت شدی، برات مهم بوده.»
                        </li>
                        <li><strong>به جای انتقاد، الگو باشید:</strong> رفتار درست شما مثل وقت‌شناسی، توجه به جزئیات و تعهد بهترین روش آموزش است. کمال‌گرایی بیش از حد باعث اضطراب کودک می‌شود.</li>
                        <li><strong>انعطاف‌پذیری را تمرین کنید:</strong> گاهی بدون برنامه، بازی، شیطنت و بی‌نظمی برای رشد کودک ضروری است. حتی اگر سخت است، اجازه دهید انتخاب‌ها و کارهایش کمی متفاوت باشد.</li>
                        <li><strong>فرزندان‌تان را مقایسه نکنید:</strong> مقایسه ناخواسته بین فرزندان می‌تواند رابطه شما با او را آسیب‌زننده کند.</li>
                    </ol>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فرزندان چگونه با والدین CIS ارتباط مؤثر برقرار کنند"
            >
                <div className='text-gray-800 leading-7'>
                    <ol className='list-decimal mr-6 mt-2 space-y-2'>
                        <li><strong>به نظم و آرامش او احترام بگذارید:</strong> برای مطرح کردن موضوعات مهم، زمان مناسب و با چارچوب مشخص صحبت کنید.</li>
                        <li><strong>از راه منطق وارد شوید:</strong> کمی منطقی و دقیق صحبت کردن به برقراری ارتباط کمک می‌کند. مثال: «من فکر کردم اگر پنجشنبه به پارک بریم هم هوا خوبه هم کار شما تموم شده.»</li>
                        <li><strong>احساسات خود را بیان کنید:</strong> والد CIS ممکن است متوجه غم، دلتنگی یا خشم شما نشود. صادقانه بگویید: «امروز خیلی خسته‌ام، دلم می‌خواست فقط با شما حرف بزنم.»</li>
                        <li><strong>مراقب انتقاد باشید، اما از گفت‌وگو نترسید:</strong> CIS از نقد بی‌منطق بیزار است، اما از گفت‌وگوی محترمانه و سازنده استقبال می‌کند.</li>
                    </ol>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد فیلم"
            >
                <div className='text-gray-800 leading-7'>
                    فیلم <strong>A Beautiful Day in the Neighborhood</strong> (روزی زیبا در محله) بر اساس رابطه احساسی بین یک فرد با رفتارهای رسمی و منطقی (روزنامه‌نگار) و مربی برنامه کودک بسیار احساسی و ارتباط‌گرا ساخته شده است.
                    این فیلم نمایش زیبایی است از اینکه چگونه می‌توان پل بین منطق و احساس ساخت.
                </div>
            </Page>
        </>
    )
}

export default CIS